<template>
  <div>
    <div v-if="loading">
      <ophq-loading />
    </div>
    <div v-else>
      <h1><ressource code="titre_page" /></h1>
      <router-view />
    </div>
  </div>
</template>

<script>
import ParamFormulaireBase from "@/components/ui/mixins/ParamFormulaireBase"
export default {
  mixins: [ParamFormulaireBase],
  mounted() {
    this.loadParams("mes_societes")
  },
  metaInfo() {
    return {
      title: this.$i18n.t("meta.mesSocietes.title")
    }
  }
}
</script>